module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "row row-wider"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "min-height": "150px"
    }
  }, [(_vm.projectLoading) ? _c('loader') : _vm._e(), _vm._v(" "), (_vm.project != null) ? _c('div', [_c('tabs', {
    attrs: {
      "nav-style": "tabs"
    },
    model: {
      value: (_vm.activeTabIndex),
      callback: function($$v) {
        _vm.activeTabIndex = $$v
      },
      expression: "activeTabIndex"
    }
  }, [_c('tab', {
    attrs: {
      "header": "Project"
    }
  }, [_c('projectHeader', {
    attrs: {
      "project": _vm.project
    }
  }), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.formDisabled
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "data-vv-scope": "tabProject"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isExistingProject),
      expression: "isExistingProject"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Project ID")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('span', {
    staticClass: "textValue"
  }, [_vm._v(_vm._s(_vm.project.projectId))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('tabProject.name')
    }
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Project Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.name),
      expression: "project.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "name",
      "type": "text",
      "placeholder": "Name",
      "aria-required": "true"
    },
    domProps: {
      "value": (_vm.project.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tabProject.name')),
      expression: "errors.has('tabProject.name')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Name is required")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('tabProject.projectTypeId')
    }
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Project Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.projectTypeId),
      expression: "project.projectTypeId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "projectTypeId",
      "aria-required": "true"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.project, "projectTypeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.projectTypeList), function(projectType) {
    return _c('option', {
      key: projectType.projectTypeId,
      domProps: {
        "value": projectType.projectTypeId
      }
    }, [_vm._v("\n                                      " + _vm._s(projectType.description) + "\n                                  ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tabProject.projectTypeId')),
      expression: "errors.has('tabProject.projectTypeId')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Project Type is required")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('tabProject.leadAgency')
    }
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Lead Agency")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.agencyId),
      expression: "project.agencyId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "agencyId",
      "aria-required": "true"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.project, "agencyId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.changeConfirm('agencyId', 'lead agency')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.leadOrganizationList), function(organization) {
    return _c('option', {
      key: organization.id,
      domProps: {
        "value": organization.id
      }
    }, [_vm._v(_vm._s(organization.description))])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tabProject.leadAgency')),
      expression: "errors.has('tabProject.leadAgency')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Lead Agency is required")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedLeadOrganization && _vm.selectedLeadOrganization.hasUsers === false && !_vm.selectedLeadOrganization.agencyNoReview),
      expression: "selectedLeadOrganization && selectedLeadOrganization.hasUsers === false && !selectedLeadOrganization.agencyNoReview"
    }],
    staticClass: "has-error"
  }, [_vm._v("\n                                  Selected Lead Agency has no Wyotrack users\n                              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Agency Number")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.agencyNumber),
      expression: "project.agencyNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "name",
      "type": "text",
      "placeholder": "Agency Number"
    },
    domProps: {
      "value": (_vm.project.agencyNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "agencyNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('tabProject.clientId')
    }
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Client")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.clientId),
      expression: "project.clientId"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.project.clientId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "clientId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedClient),
      expression: "selectedClient"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "clientId",
      "aria-required": "true"
    },
    on: {
      "input": function($event) {
        _vm.clientChange($event.target.value)
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedClient = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.organizationList), function(organization) {
    return _c('option', {
      key: organization.organizationId,
      domProps: {
        "value": organization.organizationId
      }
    }, [_vm._v("\n                                      " + _vm._s(organization.description) + "\n                                  ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tabProject.clientId')),
      expression: "errors.has('tabProject.clientId')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Client is required")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Field Org.")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.fieldOrganizationId),
      expression: "project.fieldOrganizationId"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "fieldOrganizationId"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.project, "fieldOrganizationId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.changeConfirm('fieldOrganizationId', 'field org.')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.organizationList), function(organization) {
    return _c('option', {
      key: organization.organizationId,
      domProps: {
        "value": organization.organizationId
      }
    }, [_vm._v("\n                                      " + _vm._s(organization.description) + "\n                                  ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Field Org. Number")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.fieldOrgNumber),
      expression: "project.fieldOrgNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "name",
      "type": "text",
      "placeholder": "Field Org. Number"
    },
    domProps: {
      "value": (_vm.project.fieldOrgNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "fieldOrgNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Migrated References")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gridInvMigrationRef.tableData.length > 0),
      expression: "gridInvMigrationRef.tableData.length > 0"
    }]
  }, [_c('v-client-table', {
    attrs: {
      "data": _vm.gridInvMigrationRef.tableData,
      "columns": _vm.gridInvMigrationRef.columns,
      "options": _vm.gridInvMigrationRef.options
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.inactive),
      expression: "project.inactive"
    }],
    attrs: {
      "type": "checkbox",
      "id": "IsProjectInactive"
    },
    domProps: {
      "checked": Array.isArray(_vm.project.inactive) ? _vm._i(_vm.project.inactive, null) > -1 : (_vm.project.inactive)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.project.inactive,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.project.inactive = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.project.inactive = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.project, "inactive", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "IsProjectInactive"
    }
  }, [_vm._v("Set Project Inactive?")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.project.inactive),
      expression: "project.inactive"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.inactiveComment),
      expression: "project.inactiveComment"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "inactiveComment",
      "placeholder": "Reasons for Inactive Project"
    },
    domProps: {
      "value": (_vm.project.inactiveComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "inactiveComment", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.project.inactive),
      expression: "project.inactive"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label text-label"
  }, [_vm._v("Project Status Updated By")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-label"
  }, [_vm._v("\n                              " + _vm._s(_vm.project.inactiveBy) + "\n                          ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.project.inactive),
      expression: "project.inactive"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label text-label"
  }, [_vm._v("Project Status Updated At")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-label"
  }, [_vm._v("\n                              " + _vm._s(_vm.projectInactiveDateFormatted) + "\n                          ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.isFederalAgencyImpacted),
      expression: "project.isFederalAgencyImpacted"
    }],
    attrs: {
      "type": "checkbox",
      "id": "IsFederalAgencyImpacted",
      "disabled": !_vm.isFederalAgencyImpactedCheckboxEnabled
    },
    domProps: {
      "checked": Array.isArray(_vm.project.isFederalAgencyImpacted) ? _vm._i(_vm.project.isFederalAgencyImpacted, null) > -1 : (_vm.project.isFederalAgencyImpacted)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.project.isFederalAgencyImpacted,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.project.isFederalAgencyImpacted = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.project.isFederalAgencyImpacted = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.project, "isFederalAgencyImpacted", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "IsFederalAgencyImpacted"
    }
  }, [_vm._v("Is this a federal undertaking?")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.expeditedReview),
      expression: "project.expeditedReview"
    }],
    attrs: {
      "type": "checkbox",
      "id": "expeditedReview"
    },
    domProps: {
      "checked": Array.isArray(_vm.project.expeditedReview) ? _vm._i(_vm.project.expeditedReview, null) > -1 : (_vm.project.expeditedReview)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.project.expeditedReview,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.project.expeditedReview = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.project.expeditedReview = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.project, "expeditedReview", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "expeditedReview"
    }
  }, [_vm._v("EO 14156")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isExistingProject),
      expression: "isExistingProject"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label text-label"
  }, [_vm._v("Created By")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-label"
  }, [_vm._v("\n                              " + _vm._s(_vm.project.createdBy) + "\n                          ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isExistingProject),
      expression: "isExistingProject"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label text-label"
  }, [_vm._v("Created Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-label"
  }, [_vm._v("\n                              " + _vm._s(_vm.projectCreatedDateFormatted) + "\n                          ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isExistingProject),
      expression: "isExistingProject"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label text-label"
  }, [_vm._v("Modified By")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-label"
  }, [_vm._v("\n                              " + _vm._s(_vm.project.modifiedBy) + "\n                          ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isExistingProject),
      expression: "isExistingProject"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label text-label"
  }, [_vm._v("Modified Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-label"
  }, [_vm._v("\n                              " + _vm._s(_vm.projectModifiedDateFormatted) + "\n                          ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.any()),
      expression: "errors.any()"
    }]
  }, [_c('span', {
    staticClass: "has-error"
  }, [_vm._v("Validation issues must be corrected prior to submit")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.serverErrorList.length > 0),
      expression: "serverErrorList.length > 0"
    }]
  }, [_c('span', {
    staticClass: "has-error"
  }, [_vm._v("Validation issues must be corrected prior to submit")]), _vm._v(" "), _c('ul', {
    staticClass: "has-error"
  }, _vm._l((_vm.serverErrorList), function(serverError) {
    return _c('li', {
      key: serverError
    }, [_vm._v(_vm._s(serverError))])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), (!_vm.formDisabled) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "name": "button2",
      "type": "submit"
    }
  }, [_vm._v("\n                                  " + _vm._s(_vm.isExistingProject ? 'Save' : 'Create') + "\n                              ")])]) : _vm._e()])])])], 1), _vm._v(" "), (_vm.hasSurvey) ? _c('tab', {
    attrs: {
      "header": "Building Survey",
      "disabled": !_vm.isExistingProject
    }
  }, [_c('projectHeader', {
    attrs: {
      "project": _vm.project
    }
  }), _vm._v(" "), (_vm.hasSurvey) ? _c('buildingSurveyActions', {
    attrs: {
      "project": _vm.project
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.hasE106) ? _c('tab', {
    attrs: {
      "header": "E106 Compliance",
      "disabled": !_vm.isExistingProject
    }
  }, [_c('projectHeader', {
    attrs: {
      "project": _vm.project
    }
  }), _vm._v(" "), (_vm.hasE106) ? _c('e106ComplianceActions', {
    attrs: {
      "project": _vm.project
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.hasSurvey && !_vm.hasE106) ? _c('tab', {
    attrs: {
      "header": "Actions",
      "disabled": !_vm.isExistingProject
    }
  }, [_c('projectHeader', {
    attrs: {
      "project": _vm.project
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tabContent"
  }, [_c('div', {
    staticClass: "sectionHeader"
  }, [_c('div', {
    staticClass: "sectionHeaderLeft"
  }, [_vm._v("E106 Consultation Requests")]), _vm._v(" "), (!_vm.formDisabled) ? _c('div', {
    staticClass: "sectionHeaderRight"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "to": {
        path: '/E106Compliance',
        query: {
          projectId: _vm.project.projectId
        }
      },
      "tag": "button"
    }
  }, [_vm._v("Add New")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gridSpecCompliance.tableData.length > 0),
      expression: "gridSpecCompliance.tableData.length > 0"
    }],
    staticStyle: {
      "float": "clear"
    }
  }, [_c('v-client-table', {
    attrs: {
      "data": _vm.gridSpecCompliance.tableData,
      "columns": _vm.gridSpecCompliance.columns,
      "options": _vm.gridSpecCompliance.options
    },
    scopedSlots: _vm._u([{
      key: "edit",
      fn: function(props) {
        return !_vm.isClientUser ? [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('router-link', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "font-size": "18px"
          },
          attrs: {
            "to": {
              path: '/E106Compliance/' + props.row.e106complianceId
            },
            "tag": "a"
          }
        })], 1)] : undefined
      }
    }, {
      key: "delete",
      fn: function(props) {
        return [(!_vm.formDisabled) ? _c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [(props.row.canBeDeleted) ? _c('a', {
          staticClass: "fa fa-ban",
          staticStyle: {
            "font-size": "18px"
          },
          on: {
            "click": function($event) {
              _vm.deleteCompliance(props.row.e106complianceId)
            }
          }
        }) : _vm._e()]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "sectionHeader"
  }, [_c('div', {
    staticClass: "sectionHeaderLeft"
  }, [_vm._v("Fieldwork Requests")]), _vm._v(" "), (!_vm.formDisabled) ? _c('div', {
    staticClass: "sectionHeaderRight"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "to": {
        path: '/FieldWorkRequest',
        query: {
          projectId: _vm.project.projectId
        }
      },
      "tag": "button"
    }
  }, [_vm._v("Add New")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gridSpecFielworkRequests.tableData.length > 0),
      expression: "gridSpecFielworkRequests.tableData.length > 0"
    }],
    staticStyle: {
      "float": "clear"
    }
  }, [_c('v-client-table', {
    attrs: {
      "data": _vm.gridSpecFielworkRequests.tableData,
      "columns": _vm.fwrGridSpecColumns,
      "options": _vm.gridSpecFielworkRequests.options
    },
    scopedSlots: _vm._u([{
      key: "edit",
      fn: function(props) {
        return [(!_vm.isClientUser) ? _c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('router-link', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "font-size": "18px"
          },
          attrs: {
            "to": {
              path: '/FieldWorkRequest/' + props.row.fieldworkRequestId
            },
            "tag": "a"
          }
        })], 1) : _vm._e()]
      }
    }, {
      key: "delete",
      fn: function(props) {
        return [(!_vm.formDisabled) ? _c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [(props.row.canBeDeleted) ? _c('a', {
          staticClass: "fa fa-ban",
          staticStyle: {
            "font-size": "18px"
          },
          on: {
            "click": function($event) {
              _vm.deleteFieldworkRequest(props.row.fieldworkRequestId)
            }
          }
        }) : _vm._e()]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), (!_vm.isAgencyReadOnly) ? [_c('div', {
    staticClass: "sectionHeader"
  }, [_c('div', {
    staticClass: "sectionHeaderLeft"
  }, [_vm._v("File Search")]), _vm._v(" "), (!_vm.formDisabled) ? _c('div', {
    staticClass: "sectionHeaderRight"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "to": {
        path: '/FileSearch',
        query: {
          projectId: _vm.project.projectId
        }
      },
      "tag": "button"
    }
  }, [_vm._v("Add New")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gridSpecFileSearches.tableData.length > 0),
      expression: "gridSpecFileSearches.tableData.length > 0"
    }],
    staticStyle: {
      "float": "clear"
    }
  }, [_c('v-client-table', {
    attrs: {
      "data": _vm.gridSpecFileSearches.tableData,
      "columns": _vm.gridSpecFileSearches.columns,
      "options": _vm.gridSpecFileSearches.options
    },
    scopedSlots: _vm._u([{
      key: "edit",
      fn: function(props) {
        return !_vm.isClientUser ? [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('router-link', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "font-size": "18px"
          },
          attrs: {
            "to": {
              path: '/FileSearch/' + props.row.fileSearchId
            },
            "tag": "a"
          }
        })], 1)] : undefined
      }
    }, {
      key: "result",
      fn: function(props) {
        return !_vm.isClientUser ? [(props.row.hasResults) ? _c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('router-link', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "font-size": "18px"
          },
          attrs: {
            "to": {
              path: '/FileSearch/' + props.row.fileSearchId,
              hash: '#files'
            },
            "tag": "a"
          }
        })], 1) : _vm._e()] : undefined
      }
    }, {
      key: "delete",
      fn: function(props) {
        return [(!_vm.formDisabled) ? _c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [(props.row.canBeDeleted) ? _c('a', {
          staticClass: "fa fa-ban",
          staticStyle: {
            "font-size": "18px"
          },
          on: {
            "click": function($event) {
              _vm.deleteFileSearch(props.row)
            }
          }
        }) : _vm._e()]) : _vm._e()]
      }
    }])
  })], 1)] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sectionHeader"
  }, [_c('div', {
    staticClass: "sectionHeaderLeft"
  }, [_vm._v("Investigation")]), _vm._v(" "), (!_vm.formDisabled) ? _c('div', {
    staticClass: "sectionHeaderRight"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "name": "buttonAddInvestigation"
    },
    on: {
      "click": _vm.addInvestigation
    }
  }, [_vm._v("Add New")])]) : _vm._e()]), _vm._v(" "), _c('modal', {
    ref: "investigationModal"
  }, [_c('h3', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("File Search Missing")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm._v("\n                              Before performing an investigation with a level 2 or level 3 survey, an official File Search must be completed. Would you like to create a file search, or continue to the investigation?\n                      ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('router-link', {
    staticClass: "btn btn-primary col-md-3",
    attrs: {
      "to": {
        path: '/FileSearch',
        query: {
          projectId: _vm.project.projectId
        }
      },
      "tag": "button"
    }
  }, [_vm._v("File Search")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary col-md-3",
    attrs: {
      "to": {
        path: '/Investigation',
        query: {
          projectId: _vm.project.projectId
        }
      },
      "tag": "button"
    }
  }, [_vm._v("Continue")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary col-md-3",
    attrs: {
      "name": "buttonCancel"
    },
    on: {
      "click": function($event) {
        _vm.$refs['investigationModal'].close()
      }
    }
  }, [_vm._v(" Cancel ")])], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gridSpecInvestigations.tableData.length > 0),
      expression: "gridSpecInvestigations.tableData.length > 0"
    }],
    staticStyle: {
      "float": "clear"
    }
  }, [_c('v-client-table', {
    attrs: {
      "data": _vm.gridSpecInvestigations.tableData,
      "columns": _vm.gridSpecInvestigations.columns,
      "options": _vm.gridSpecInvestigations.options
    },
    scopedSlots: _vm._u([{
      key: "edit",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('router-link', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "font-size": "18px"
          },
          attrs: {
            "to": {
              path: '/Investigation/' + props.row.investigationId
            },
            "tag": "a"
          }
        })], 1)]
      }
    }, {
      key: "resources",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [(props.row.siteCount > 0 || props.row.isolateCount > 0) ? _c('span', [_vm._v("Yes ")]) : _vm._e(), _vm._v(" "), (props.row.siteCount > 0 || props.row.isolateCount > 0) ? _c('router-link', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "font-size": "16px"
          },
          attrs: {
            "to": {
              path: '/Investigation/' + props.row.investigationId,
              hash: '#siteSummary'
            },
            "tag": "a"
          }
        }) : _c('span', [_vm._v("No")])], 1)]
      }
    }, {
      key: "delete",
      fn: function(props) {
        return [(!_vm.formDisabled) ? _c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [(props.row.canBeDeleted) ? _c('a', {
          staticClass: "fa fa-ban",
          staticStyle: {
            "font-size": "18px"
          },
          on: {
            "click": function($event) {
              _vm.deleteInvestigation(props.row)
            }
          }
        }) : _vm._e()]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), (!_vm.isConsultant) ? _c('div', [_c('div', {
    staticClass: "sectionHeader"
  }, [_c('div', {
    staticClass: "sectionHeaderLeft"
  }, [_vm._v("Undertaking")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gridSpecUt.tableData.length > 0),
      expression: "gridSpecUt.tableData.length > 0"
    }],
    staticStyle: {
      "float": "clear"
    }
  }, [_c('v-client-table', {
    attrs: {
      "data": _vm.gridSpecUt.tableData,
      "columns": _vm.gridSpecUt.columns,
      "options": _vm.gridSpecUt.options
    },
    scopedSlots: _vm._u([{
      key: "edit",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('router-link', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "font-size": "18px"
          },
          attrs: {
            "to": {
              path: '/Undertaking/' + props.row.undertakingId
            },
            "tag": "a"
          }
        })], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "sectionHeader"
  }, [_c('div', {
    staticClass: "sectionHeaderLeft"
  }, [_vm._v("MOA/PA")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gridSpecMoa.tableData.length > 0),
      expression: "gridSpecMoa.tableData.length > 0"
    }],
    staticStyle: {
      "float": "clear"
    }
  }, [_c('v-client-table', {
    attrs: {
      "data": _vm.gridSpecMoa.tableData,
      "columns": _vm.gridSpecMoa.columns,
      "options": _vm.gridSpecMoa.options
    },
    scopedSlots: _vm._u([{
      key: "edit",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('router-link', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "font-size": "18px"
          },
          attrs: {
            "to": {
              path: '/Moa/' + props.row.moaId
            },
            "tag": "a"
          }
        })], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gridSpecPa.tableData.length > 0),
      expression: "gridSpecPa.tableData.length > 0"
    }],
    staticStyle: {
      "float": "clear"
    }
  }, [_c('v-client-table', {
    attrs: {
      "data": _vm.gridSpecPa.tableData,
      "columns": _vm.gridSpecPa.columns,
      "options": _vm.gridSpecPa.options
    },
    scopedSlots: _vm._u([{
      key: "edit",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('router-link', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "font-size": "18px"
          },
          attrs: {
            "to": {
              path: '/Pa/' + props.row.paId
            },
            "tag": "a"
          }
        })], 1)]
      }
    }])
  })], 1)]) : _vm._e()], 2)], 1) : _vm._e(), _vm._v(" "), (!_vm.isAgencyReadOnly && !_vm.isClientUser) ? _c('tab', {
    attrs: {
      "header": "Organizations",
      "disabled": !_vm.isExistingProject
    }
  }, [_c('projectHeader', {
    attrs: {
      "project": _vm.project
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sectionHeader"
  }, [_c('div', {
    staticClass: "sectionHeaderLeft"
  }, [_vm._v("View Only Organizations")]), _vm._v(" "), _c('div', {
    staticClass: "sectionHeaderRight"
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "padding-right": "12px"
    }
  }, [(_vm.showAddViewOnlyOrganization) ? _c('div', [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "searchFieldOrgName"
    }
  }, [_vm._v("Field Org. Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projectViewOnlyOrganizationId),
      expression: "projectViewOnlyOrganizationId"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "fieldOrganizationId"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.projectViewOnlyOrganizationId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.organizationList), function(organization) {
    return _c('option', {
      key: organization.organizationId,
      domProps: {
        "value": organization.organizationId
      }
    }, [_vm._v("\n                                          " + _vm._s(organization.description) + "\n                                      ")])
  })], 2)])]) : _vm._e(), _vm._v(" "), (!_vm.formDisabled) ? _c('div', {
    staticClass: "btn",
    class: _vm.showAddViewOnlyOrganization ? 'btn-danger btn col-md-4' : 'btn-primary',
    on: {
      "click": _vm.handleViewOnlyOrganization
    }
  }, [_vm._v(_vm._s(_vm.showAddViewOnlyOrganization ? 'Grant View Only Access' : 'Add New'))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gridProjectViewOnlyOrganizations),
      expression: "gridProjectViewOnlyOrganizations"
    }],
    staticStyle: {
      "float": "clear"
    }
  }, [_c('v-client-table', {
    attrs: {
      "data": _vm.gridProjectViewOnlyOrganizations.tableData,
      "columns": _vm.gridProjectViewOnlyOrganizations.columns,
      "options": _vm.gridProjectViewOnlyOrganizations.options
    },
    scopedSlots: _vm._u([{
      key: "delete",
      fn: function(props) {
        return [(!_vm.formDisabled) ? _c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('a', {
          staticClass: "fa fa-ban",
          staticStyle: {
            "font-size": "18px"
          },
          on: {
            "click": function($event) {
              _vm.deleteProjectOrgViewOnly(props.row)
            }
          }
        })]) : _vm._e()]
      }
    }])
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "sectionHeader"
  }, [_c('div', {
    staticClass: "sectionHeaderLeft"
  }, [_vm._v("Project Organization History")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gridProjectOrganizationHistory.tableData.length > 0),
      expression: "gridProjectOrganizationHistory.tableData.length > 0"
    }],
    staticStyle: {
      "float": "clear"
    }
  }, [_c('v-client-table', {
    attrs: {
      "data": _vm.gridProjectOrganizationHistory.tableData,
      "columns": _vm.gridProjectOrganizationHistory.columns,
      "options": _vm.gridProjectOrganizationHistory.options
    }
  })], 1)], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDebug),
      expression: "isDebug"
    }]
  }, [_vm._m(1), _vm._v(" "), _c('div', [_c('h4', [_vm._v("project: ")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.project))])]), _vm._v(" "), _c('div', [_c('h4', [_vm._v("Validation errors: ")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.errors))])]), _vm._v(" "), _c('div', [_c('h4', [_vm._v("selectedLeadOrganization: ")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.selectedLeadOrganization))])]), _vm._v(" "), _c('div', [_c('h4', [_vm._v("isFederalAgencyImpactedCheckboxEnabled: ")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.isFederalAgencyImpactedCheckboxEnabled))])]), _vm._v(" "), _c('div', [_c('h4', [_vm._v("hasSurvey: ")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.hasSurvey))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Project")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "text-danger"
  }, [_vm._v("****** Debug ******")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a3f573f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Project.vue
// module id = 982
// module chunks = 1